import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NotificationService, StringService} from '../../services';
import {Footer, Loader} from '../../components';
import {
  processarAutorizacao,
  consultarTermosUso,
  updateAutorizacao,
  processaSituacaoPortadorFinalizada,
} from '../../ducks/Customer';
import {
  redirectToYourCard,
  redirectToValidationAccessCode,
  redirectToSignature,
} from '../../ducks/Navigate';
import {Messages, RouteKeys} from '../../constants';
import './styles.scss';

class TermsAccept extends Component {
  state = {
    numeroTentativas: 1,
    notification: null,
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.TermsAccept.title);

    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    )
      this.props.consultarTermosUso(this.props.chave);
  }

  validateTerms = () => {
    return this.props.autorizacao.every((termo) => termo.checked);
  };

  iniciarProcessoAutorizacoes = () => {
    let notification = NotificationService.showMessageWithoutButton(
      'Estamos preparando o seu contrato para a assinatura digital.',
    );
    this.setState({notification});
  };

  finalizarProcessoAutorizacoes = () => {
    this.state.notification.close();
    let numeroTentativas = 1;
    this.setState({numeroTentativas});
  };

  processaAutorizacao = async () => {
    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      let chave = this.props.chave;
      const dados = {
        chave,
        autorizacao: this.props.autorizacao,
      };
      const processarAutorizacaoResponse =
        await this.props.processarAutorizacao(dados);
      let registrarDenovo = false;

      if (!processarAutorizacaoResponse.sucesso) {
        if (this.state.numeroTentativas < 5) {
          registrarDenovo = true;
        } else {
          this.finalizarProcessoAutorizacoes();

          NotificationService.showValidationSingleError(
            Messages.ErrorTryAgainMessage,
          ).then(() => {
            this.props.redirectToValidationAccessCode();
          });
        }

        let {numeroTentativas} = this.state;
        numeroTentativas++;
        this.setState({numeroTentativas});

        if (registrarDenovo) {
          setTimeout(this.processaAutorizacao, 10000);
        }
      } else {
        this.finalizarProcessoAutorizacoes();
        this.props.redirectToSignature();
      }
    } else this.finalizarProcessoAutorizacoes();
  };

  nextHandle = (event) => {
    event.preventDefault();
    this.iniciarProcessoAutorizacoes();

    if (this.validateTerms()) {
      this.processaAutorizacao();
    } else {
      NotificationService.showValidationSingleError(
        Messages.RequiredAuthorizationTermsMessage,
      );
    }
  };

  handleChange = (prop, value) => {
    this.props.updateAutorizacao({prop, value});
  };

  render() {
    const characterLimit = 100;
    return (
      <div className="autorization-container">
        <Loader />
        <div className="content">
          <header>Autorização de seguro</header>
          {this.props.autorizacao &&
            this.props.autorizacao.map((a, indice) => (
              <article key={indice} className="autorization">
                <div className="text-group">
                  <input
                    type="checkbox"
                    className="read-more-state"
                    id={`read_terms_${indice}`}
                  />
                  <input
                    className="styled-checkbox"
                    id={`accept_terms_${indice}`}
                    type="checkbox"
                    checked={a.checked}
                    onChange={(ev) =>
                      this.handleChange(a.codigo, ev.target.checked)
                    }
                  />
                  <label htmlFor={`accept_terms_${indice}`}></label>
                  <label htmlFor={`accept_terms_${indice}`} className="text">
                    {a.termo ? a.termo.substring(0, characterLimit) : ''}
                    <span className="read-more-target">
                      {a.termo ? a.termo.substring(characterLimit) : ''}
                      {a.link && (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={a.link}
                          className="link"
                        >
                          <img
                            src="img/question-circle.svg"
                            alt="Leia mais"
                            width="20"
                          />
                        </a>
                      )}
                    </span>
                    <label
                      htmlFor={`read_terms_${indice}`}
                      className="read-more-trigger"
                    ></label>
                  </label>
                </div>
              </article>
            ))}
        </div>
        <div className="footer-container">
          <Footer
            textNext="Avançar"
            nextHandle={this.nextHandle}
            backHandle={() => {
              this.props.redirectToYourCard();
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({customer, select}) => {
  const {chave, autorizacao} = customer;
  const {termos} = select;
  return {
    chave,
    autorizacao,
    termos,
  };
};
export default connect(mapStateToProps, {
  processarAutorizacao,
  redirectToYourCard,
  consultarTermosUso,
  updateAutorizacao,
  redirectToValidationAccessCode,
  redirectToSignature,
  processaSituacaoPortadorFinalizada,
})(TermsAccept);
